import { render } from "./ihbook_page_ii.vue?vue&type=template&id=853afbbc&scoped=true"
const script = {}

import "./ihbook_page_ii.vue?vue&type=style&index=0&id=853afbbc&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853afbbc"]])

export default __exports__